import { makeStyles } from '@material-ui/core/styles'

import colors from '@galo-monitor/styles/colors'

export default makeStyles({
  root: {
    marginTop: 15,
    marginBottom: 10,

    '& > div:first-child': {
      backgroundColor: colors.backgroundHtml
    }
  }
})
